export const LISTAR_URAS = 'LISTAR_URAS'
export const LISTAR_URA_SELECIONADA = 'LISTAR_URA_SELECIONADA'
export const GET_URA_USE = 'GET_URA_USE'
export const LISTAR_ROTAS = 'LISTAR_ROTAS'
export const LISTAR_AUDIOS = 'LISTAR_AUDIOS'
export const LISTAR_GRUPOS_DE_ROTAS = 'LISTAR_GRUPOS_DE_ROTAS'
